import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Desplegable from "../../desplegable";
import FormIdiomas from "../formularios/form_idiomas";
import $ from "jquery";

export default class Vistaidiomas extends Component {
  constructor(props) {
    super(props);
    this.mostrarIdiomas = this.mostrarIdiomas.bind(this);
    this.deleteIdioma = this.deleteIdioma.bind(this);
  }

  //DELETE
  //Implementado en la vista borra aquellos desplegables de desplegables
  deleteIdioma(id) {
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/idiomas/" + $this[0].props.DatosUsuario.datosIdiomas.idiomas[id].id,
      method: "DELETE",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha eliminado correctamente", "success");
        $this[0].props.deleteIdioma(id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  mostrarIdiomas() {
    let longitud = 0;
    let idiomas = null;
    let languageLevel = "language_level.type";
    let ArrayIdiomas = [];

    if (this.props.DatosUsuario.datosIdiomas) {
      longitud = this.props.DatosUsuario.datosIdiomas.idiomas.length;
    }
    for (let i = 0; i < longitud; i++) {
      idiomas = (
        <Container>
          <Row>
            <Col lg="6" className="border">
              <h6>Idioma</h6>
              <p>{this.props.DatosUsuario.datosIdiomas.idiomas[i].name}</p>
            </Col>
            <Col lg="6" className="border">
              <h6>Nivel</h6>
              <p>{this.props.DatosUsuario.datosIdiomas.idiomas[i][languageLevel]}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="border">
              <h6>Titulación</h6>
              <p>{this.props.DatosUsuario.datosIdiomas.idiomas[i].certificate}</p>
            </Col>
          </Row>
        </Container>
      );
      ArrayIdiomas.push(
        <Desplegable
          handleButtonShow={this.props.handleButtonShow}
          showModal={this.props.showModalIdiomasArray[i]}
          Toogle={this.props.DatosUsuario.datosIdiomas.idiomas[i].name + " " + this.props.DatosUsuario.datosIdiomas.idiomas[i]["language_level.type"]}
          id={i}
          key={this.props.DatosUsuario.datosIdiomas.idiomas[i].id}
          value={"6"}
          Text={idiomas}
          deleteFunction={this.deleteIdioma}
          Form={
            <FormIdiomas
              DatosUsuario={this.props.DatosUsuario}
              setIdioma={this.props.setIdioma}
              putIdioma={this.props.putIdioma}
              handleButtonShow={this.props.handleButtonShow}
              id={i}
              setAlert={this.props.setAlert}
            ></FormIdiomas>
          }
          canEdit={true}
        />
      );
    }
    if (longitud === 0)
      ArrayIdiomas.push(
        <p className="ml-3" key={2}>
          No hay datos actualmente
        </p>
      );
    return ArrayIdiomas;
  }
  render() {
    return <React.Fragment>{this.mostrarIdiomas()}</React.Fragment>;
  }
}
